import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_NIVELES_ACADEMICOS,
  ALL_NIVELES_ACADEMICOS,
  LOADING_ALL_NIVELES_ACADEMICOS,
} from './NivelesAcademicosReducer';
import {
  deleteNivelesAcademicosService,
  allNivelesAcademicosService,
  oneNivelesAcademicosService,
  saveNivelesAcademicosService,
} from './NivelesAcademicosService';

export const allNivelesAcademicosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_NIVELES_ACADEMICOS, payload: true });
    const res = await allNivelesAcademicosService(params);
    dispatch({ type: ALL_NIVELES_ACADEMICOS, payload: res.data });
    dispatch({ type: LOADING_ALL_NIVELES_ACADEMICOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_NIVELES_ACADEMICOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveNivelesAcademicosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveNivelesAcademicosService(id, data);
    notify(res.data.message);
    await allNivelesAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoNivelesAcademicosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_NIVELES_ACADEMICOS, payload: data });
};

export const oneNivelesAcademicosAction = async (dispatch, id) => {
  try {
    const res = await oneNivelesAcademicosService(id);
    await setActivoNivelesAcademicosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteNivelesAcademicosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteNivelesAcademicosService(id);
    notify(res.data.message);
    await setActivoNivelesAcademicosAction(dispatch, null);
    await allNivelesAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
